import { Section, ChecklistItemsConfig } from '../components'

export const ChecklistItemsConfigPage = () => {
  return (
    <Section>
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <h2>Checklist Items Config</h2>
            <ChecklistItemsConfig />
          </div>
        </div>
      </div>
    </Section>
  )
}
